<section class="section-div">
  <div class="header-div">
    <h4><i class="fas fa-hand-holding-usd mr-2"></i>Revenue Generation</h4>
  </div>
  <form action="" [formGroup]="revenues">
    <div class="text-right">
      <button
        class="btn btn-primary mb-2"
        (click)="addRevenue()"
        [ngClass]="{ 'disabled-btn': showForm }"
        [disabled]="showForm"
      >
        Add Revenue
      </button>
    </div>
    <table class="table">
      <thead
        style="
          padding: 18px;
          background-color: #0c0249;
          color: white;
          text-align: center;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
        "
      >
        <tr>
          <th scope="col">S.No</th>
          <th scope="col">Means of Revenue Generation Year 1 Year 2 Total</th>
          <th scope="col">Year 1</th>
          <th scope="col">Year 2</th>
          <th scope="col">Total</th>
          <th scope="col" *ngIf="!showForm">Action</th>
        </tr>
      </thead>
      <tbody
        style="
          background-color: #fff;
          text-align: center;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
        "
      >
        <tr
          *ngFor="let item of revenue.controls; let i = index"
          [formGroup]="item"
        >
          <th scope="row" class="mar-top">{{ i + 1 }}</th>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label
                  >Description <span class="text-danger">*</span></mat-label
                >
                <textarea
                  matInput
                  placeholder="Enter Description"
                  readonly="{{ showForm }}"
                  formControlName="description"
                  cols="30"
                  rows="2"
                  type="text"
                  #message
                  maxlength="3000"
                ></textarea>
                <mat-hint matSuffix>{{ message.value.length }}</mat-hint>
                <mat-error
                  *ngIf="
                    item.get('description').touched &&
                    item.get('description').errors
                  "
                >
                  <span *ngIf="item.get('description').errors.required"
                    >Description is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label
                  >Amount (INR) <span class="text-danger">*</span></mat-label
                >
                <input
                  matInput
                  placeholder="Enter Amount"
                  type="text"
                  readonly="{{ showForm }}"
                  formControlName="year1"
                  (input)="calculateTotal1()"
                  oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                  maxlength="11"
                  (keydown.enter)="preventEnterKey($event)"
                />
                <mat-error
                  *ngIf="item.get('year1').touched && item.get('year1').errors"
                >
                  <span *ngIf="item.get('year1').errors.required">
                    Amount is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label
                  >Amount (INR) <span class="text-danger">*</span></mat-label
                >
                <input
                  matInput
                  placeholder="Enter Amount"
                  type="text"
                  readonly="{{ showForm }}"
                  formControlName="year2"
                  (input)="calculateTotal1()"
                  oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                  maxlength="11"
                  (keydown.enter)="preventEnterKey($event)"
                />
                <mat-error
                  *ngIf="item.get('year2').touched && item.get('year2').errors"
                >
                  <span *ngIf="item.get('year2').errors.required">
                    Amount is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
          </td>

          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>Total Amount (INR)</mat-label>
                <input
                  matInput
                  placeholder="Total"
                  type="text"
                  readonly
                  formControlName="total"
                  oninput="this.value = this.value.replace(/^(\.)|^0(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                />
              </mat-form-field>
            </div>
          </td>
          <td class="text-center" *ngIf="!showForm">
            <i
              class="fas fa-trash delete-i mar-top"
              (click)="deleteRow(i, item.get('id').value)"
              aria-hidden="true"
            ></i>
          </td>
        </tr>
        <tr>
          <th scope="row" class="pt-4"></th>
          <td class="pt-4 text-right">Total</td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>Total Amount (INR) </mat-label>
                <input
                  matInput
                  placeholder="Total Amount"
                  type="text"
                  readonly
                  formControlName="totalYear1"
                  oninput="this.value = this.value.replace(/^(\.)|^0(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                />
                <mat-error
                  *ngIf="
                    setting.totalYear1?.touched && setting.totalYear1?.errors
                  "
                >
                  <span *ngIf="setting.totalYear1?.errors?.required"
                    >Total Amount is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>Total Amount (INR) </mat-label>
                <input
                  matInput
                  placeholder="Total Amount"
                  type="text"
                  readonly
                  formControlName="totalYear2"
                  oninput="this.value = this.value.replace(/^(\.)|^0(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                />
                <mat-error
                  *ngIf="
                    setting.totalYear2?.touched && setting.totalYear2?.errors
                  "
                >
                  <span *ngIf="setting.totalYear2?.errors?.required"
                    >Total Amount is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
          </td>
          <td>
            <div class="form-rows">
              <mat-form-field class="material-full-width" appearance="outline">
                <mat-label>Total Amount (INR)</mat-label>
                <input
                  matInput
                  placeholder="Total Amount"
                  type="text"
                  readonly
                  formControlName="overrallTotal"
                  oninput="this.value = this.value.replace(/^(\.)|^0(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                />
                <mat-error
                  *ngIf="
                    setting.overrallTotal?.touched &&
                    setting.overrallTotal?.errors
                  "
                >
                  <span *ngIf="setting.overrallTotal?.errors?.required"
                    >Total Amount is required</span
                  >
                </mat-error>
              </mat-form-field>
            </div>
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
    <div class="text-center mt-3">
      <button
        mat-raised-button
        color="primary"
        (click)="saveBtn()"
        *ngIf="!showForm"
      >
        Save & Continue
      </button>
    </div>
  </form>
</section>
